import { ActionReducerMap } from '@ngrx/store';
import { AccountManagementState } from './account-management.state';
import * as fromManagement from './management';
import * as fromAccountLanguages from './account-languages';

export const reducers: ActionReducerMap<AccountManagementState> = {
    management: fromManagement.managementReducer,
    languages: fromAccountLanguages.accountLanguagesReducer
}
